import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Gift } from "lucide-react";
import LeadForm from "@/components/landing/LeadForm";

export default function ExitIntent() {
  const [show, setShow] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("exit_shown")) return;
    const handler = (e) => {
      if (e.clientY <= 0) {
        setShow(true);
        sessionStorage.setItem("exit_shown", "1");
        window.removeEventListener("mouseout", handler);
      }
    };
    const t = setTimeout(() => window.addEventListener("mouseout", handler), 4000);
    return () => { clearTimeout(t); window.removeEventListener("mouseout", handler); };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] grid place-items-center p-4 bg-secondary/60 backdrop-blur-sm"
          onClick={() => setShow(false)}
          data-testid="exit-intent-overlay"
        >
          <motion.div
            initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.92, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-lg rounded-3xl bg-white/90 backdrop-blur-xl backdrop-saturate-150 border border-white/40 p-8 shadow-2xl"
            data-testid="exit-intent-modal"
          >
            <button onClick={() => setShow(false)} className="absolute top-5 right-5 text-muted-foreground hover:text-secondary" data-testid="exit-close-btn"><X size={22} /></button>
            {done ? (
              <div className="text-center py-8">
                <h3 className="font-display font-bold text-3xl text-secondary tracking-tight">Obrigado! 🌿</h3>
                <p className="mt-3 text-muted-foreground">Recebemos seu contato e vamos falar com você em breve.</p>
              </div>
            ) : (
              <>
                <span className="inline-flex items-center gap-2 rounded-full bg-accent/15 text-accent-foreground px-3 py-1 overline mb-4"><Gift size={14} className="text-accent" /> Oferta especial</span>
                <h3 className="font-display font-bold text-3xl sm:text-4xl text-secondary tracking-tighter leading-tight">Espere! Consultoria gratuita antes de sair</h3>
                <p className="mt-3 text-muted-foreground">Deixe seu contato e receba uma análise personalizada de economia — 100% gratuita e sem compromisso.</p>
                <div className="mt-6">
                  <LeadForm compact testPrefix="lead-exit" onSuccess={() => setDone(true)} />
                </div>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
